"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = moneyToMoneyDivided;

function moneyToMoneyDivided(money) {
  var pp = Math.floor(money / 10000);
  var gp = Math.floor((money - pp * 10000) / 100);
  var cp = money - pp * 10000 - gp * 100;
  return {
    pp: pp,
    gp: gp,
    cp: cp
  };
}